module.exports = __webpack_public_path__ + "img/equalizer-fill.eb66adf4.svg";